import clsx from 'clsx';

import styles from './Overlay.module.scss';

export function Overlay({ visible, onClick }: { visible: boolean; onClick: () => void }) {
  return (
    <div
      role="presentation"
      className={clsx(styles.overlay, { [styles.overlay_visible]: visible })}
      onClick={onClick}
    />
  );
}
